import { buildWorldMap } from './world-map-data.js';
import { useSiteLang } from '../layout/use-site-lang.js';

/**
 * Static world map showing where Thyme's languages are spoken. Rendered
 * entirely from deterministic data at SSR time — supported countries get the
 * green fill, everything else a light outline, and small supported
 * territories (Singapore, Barbados) get a pin. The projection orientation
 * follows the active site language.
 * @returns {JSX.Element}
 */
export function WorldMap() {
	const lang = useSiteLang();
	const map = buildWorldMap(lang);

	return (
		<svg
			className="language-map"
			viewBox={map.viewBox}
			width={map.width}
			height={map.height}
			role="img"
			aria-label="World map of Thyme-supported languages"
		>
			<g>
				{map.countries.map((country) => (
					<path
						key={country.name}
						className={country.supported ? 'country supported' : 'country unsupported'}
						d={country.d}
					/>
				))}
			</g>
			<g>
				{map.pins.map((pin) => (
					<circle key={pin.name} className="pin" cx={pin.x} cy={pin.y} r={3.4} />
				))}
			</g>
		</svg>
	);
}
